import React from "react";
import { Modal, Spinner } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./LoaderModal.css";
function LoadingModal({ show }) {
  return (
    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
      centered
      className="loading-modal"
    >
      <Modal.Body className="text-center py-5 ">
        <Spinner className="spinner" animation="border" variant="primary" />
        <p className="mt-3">Loading...</p>
      </Modal.Body>
    </Modal>
  );
}

export default LoadingModal;
